export enum StatusActive {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}
